import React from 'react'
import { Link } from 'react-router-dom'

export default function Footer() {
  return (
    <div>
           {/* Footer Start */}
    <div
      className="container-fluid bg-dark text-light footer pt-5 mt-5 wow fadeIn"
      data-wow-delay="0.1s"
    >
      <div className="container py-5">
        <div className="row g-5">
          <div className="col-lg-4 col-md-6">
            <h4 className="text-white mb-3">Company</h4>
            <Link to="/About" className="btn btn-link">
              About Us
            </Link>
            <Link to="/Contact" className="btn btn-link">
              Contact Us
            </Link>
        
          </div>
          <div className="col-lg-4 col-md-6">
            <h4 className="text-white mb-3">Contact</h4>
            <p className="mb-2">
              <i className="fa fa-map-marker-alt me-3" />
              20, Green height campus, Gulmohar colony, Bhopal
            </p>
            <p className="mb-2">
              <i className="fa fa-phone-alt me-3" />
              +91 7828947721
            </p>
            <p className="mb-2">
              <i className="fa fa-phone-alt me-3" />
              +91 8770273787
            </p>
            <p className="mb-2">
              <i className="fa fa-envelope me-3" />
              theholidayroyal@gmail.com
            </p>
            <p className="mb-2">
              <a
                className="text-light text-decoration-none"
                href="https://www.instagram.com/holidayroyalindia"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fab fa-instagram me-3" />
                Instagram
              </a>
            </p>
          </div>
          <div className="col-lg-4 col-md-6">
            <h4 className="text-white mb-3">Gallery</h4>
            <div className="row g-2 pt-2">
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/package-1.jpg"
                  alt="Package Gallery"
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/package-2.jpg"
                  alt="Package Gallery"
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/package-3.jpg"
                  alt="Package Gallery"
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/package-2.jpg"
                  alt="Package Gallery"
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/package-3.jpg"
                  alt="Package Gallery"
                />
              </div>
              <div className="col-4">
                <img
                  className="img-fluid bg-light p-1"
                  src="assets/img/package-1.jpg"
                  alt="Package Gallery"
                />
              </div>
            </div>
          </div>
      
        </div>
      </div>
      <div className="container">
        <div className="copyright">
          <div className="row">
            <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
              ©{" "}
              <span className="border-bottom">
                 Holiday Royal
              </span>
              , All Right Reserved.
            </div>
            <div className="col-md-6 text-center text-md-end">
              <div className="footer-menu">
                <Link to="/">Home</Link>
           
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* Footer End */}
    </div>
  )
}
